export default __webpack_public_path__ + "static/media/logo-encrypted.eab0b873.png";